// extracted by mini-css-extract-plugin
export default {"wrapper":"pagination_wrapper__WN+l1","nextAndPrev":"pagination_nextAndPrev__DILLO","loadmoreButton":"pagination_loadmoreButton__gpB-2","leftAuto":"pagination_leftAuto__Ejdw8"};